export default __webpack_public_path__ + "static/media/hema.72af4d0b.jpg";